import React from 'react';
import { ArrowLeftRight, Eye } from 'lucide-react';
import { Button } from '../ui';

/**
 * Above the suppliers of a spec the line does not have: they are shown
 * read-only, and one button switches the line to that spec.
 */
interface SpecPreviewBarProps {
  specGroup: string;
  /** "40C". */
  label: string;
  /** Absent (view-only) → no switch offered. */
  onUse?: (specGroup: string) => void;
  switching?: string | null;
}

export const SpecPreviewBar: React.FC<SpecPreviewBarProps> = ({ specGroup, label, onUse, switching = null }) => (
  <div className="flex shrink-0 flex-wrap items-center gap-x-s3 gap-y-s2 rounded-card border border-line bg-canvas px-s4 py-[8px]">
    <Eye className="h-[14px] w-[14px] shrink-0 text-ink-muted" aria-hidden />
    <span className="min-w-0 flex-1 text-body-sm text-ink-secondary">
      <strong className="font-semibold text-ink">Preview</strong>
      {onUse ? ` · use ${label} for this line to shortlist` : ` · ${label}`}
    </span>
    {onUse && (
      <Button
        variant="primary"
        size="sm"
        iconLeft={<ArrowLeftRight />}
        loading={switching === specGroup}
        loadingLabel="Switching…"
        disabled={Boolean(switching)}
        onClick={() => onUse(specGroup)}
      >
        Use {label} for this line
      </Button>
    )}
  </div>
);

export default SpecPreviewBar;
